import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { generatePath, useHistory } from 'react-router';

// Components
import UpcomingAssessmentSessions from './upcoming-assessment-sessions.component';
import Fuse from 'fuse.js';
import { providedMemberHasAnyRoles } from '../../../lib/services/user.service';
import { ROLES, STAFF_PATHS } from '../../../../_configuration';
import { getCurrMember } from '../../../lib/services/member.service';

interface IUpcomingAssessmentSessionsContainer {
  assessmentSessions: IAssessmentSession[];
  loading: boolean;
  fetchError: boolean;
}

export const UpcomingAssessmentSessionsContainer: React.FC<IUpcomingAssessmentSessionsContainer> = ({
  assessmentSessions,
  loading,
  fetchError
}) => {
  const history = useHistory();
  const [filteredSessions, setFilteredSessions] = useState<IAssessmentSession[]>(assessmentSessions);
  const [todaySessions, setTodaySessions] = useState<IAssessmentSession[]>([]);
  const [pastSessions, setPastSessions] = useState<IAssessmentSession[]>([]);
  const [upcomingSessions, setUpcomingSessions] = useState<IAssessmentSession[]>([]);

  useEffect(() => {
    const today = dayjs().format('YYYY/MM/DD');

    setTodaySessions(_.filter(filteredSessions, session => session.date === today));
    setPastSessions(_.filter(filteredSessions, session => session.date < today));
    setUpcomingSessions(_.filter(filteredSessions, session => session.date > today));
  }, [filteredSessions]);

  const {member} = getCurrMember()
  const canCheckIn = useMemo(() => {
    const assessmentId = assessmentSessions.length ? assessmentSessions[0]?.assessmentId : undefined
    if (member && assessmentId) {
      return providedMemberHasAnyRoles({member, roles: [ROLES.CHECK_IN], assessmentId})
    }
    
    return false
  }, [assessmentSessions, member])

  const selectSession = useCallback((session: IAssessmentSession) => history.push(generatePath(canCheckIn ? STAFF_PATHS.CHECK_IN : STAFF_PATHS.EVALUATE, { assessmentSessionId: session._id })), [canCheckIn, history]);

  const [searchTerm, setSearchTerm] = useState('');
  const fuse = new Fuse(assessmentSessions, { threshold: 0.3, keys: ['location', 'address', 'date'] });

  useEffect(() => {
    if (searchTerm.length) {
      const results = fuse.search(searchTerm);

      setFilteredSessions(_.map(results, 'item'));
    } else {
      setFilteredSessions(assessmentSessions);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentSessions.length, searchTerm]);

  const debounceSearch = useCallback(_.debounce((nextSearch: string) => {
    setSearchTerm(nextSearch)
  }, 300), []);

  return <UpcomingAssessmentSessions
    todaySessions={todaySessions}
    pastSessions={pastSessions}
    upcomingSessions={upcomingSessions}
    selectSession={selectSession}
    search={debounceSearch}
    loading={loading}
    fetchError={fetchError}
  />;
};
